export default "__VITE_ASSET__kPrOq04o__"